import { Helmet } from 'react-helmet';
import AddComponent from '../../../components/Admin/AddComponent/AddComponent';
import { componentsOptionsList } from '../constants';

const CreateComponent = () => {
  return (
    <>
      <Helmet>
        <title>Create Ev Story</title>
        <meta content="Create Ev Story" name="description" />
      </Helmet>
      <div className="lg:col-span-4 col-span-5">
        <AddComponent optionsList={componentsOptionsList} />
      </div>
    </>
  );
};

export default CreateComponent;
